<template>
    <div class="main-wrapper">
        <layout-header />

        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><vendor-sidebar></vendor-sidebar></div>
                        </div>
                    </div>

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3 d-flex justify-content-between align-items-center">
                            <h2 class="mb-0">Calendrier</h2>
                        </div>

                        <div class="tab-content pt-0">
                            <div class="row mb-4">
                                <div class="col-lg-5">
                                    <div class="card-label mx-2 mb-1">
                                        <label>Date/Période</label>
                                        <input type="text" class="form-control" v-model="currentTitle" required readonly/>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-sm-6">
                                    <div class="card-label mx-2 mb-1" v-if="currentUser.role != 'owner'" >
                                        <label>Espace</label>
                                        <select v-model="selectedEstablishment" class="form-control custom-select" required>
                                            <option v-for="e in establishments" :value="e">{{ e.business_name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-6">
                                    <div class="card-label mx-2 mb-1">
                                        <label>Terrain</label>
                                        <select v-model="selectedFacility" class="form-control custom-select" required>
                                            <option v-for="facility in facilities" :value="facility.id">{{ facility.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-5">
                                <FullCalendar ref="fullCalendar" :options="calendarOptions" />
                            </div>

                            <div class="col-12 text-center text-muted text-sm position-relative mt-3 mb-1" v-if="viewMode === 'day' && false">
                                <hr class="position-absolute inset-0 my-0" style="top: 50%;"/>
                                <span class="my-2 px-3 bg-white position-relative">Séries des Créneaux</span>
                            </div>
                            <div v-if="viewMode === 'day' && slotSeries.length == 0" class="text-center">
                                <span class="text-sm d-block mb-4 mt-2">Aucune série.</span>
                            </div>
                            <div v-else-if="viewMode === 'day'" class="mb-5">
                                <div class="table-responsive text-xs p-0 py-2">
                                    <table class="table table-hover table-center mb-0">
                                        <thead class="bg-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Du/À/Chaque</th>
                                                <th>Jour(s)/Intervalle</th>
                                                <th>Statut/Nouveau Prix</th>
                                                <th>Désactivée le</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in paginatedData" :key="item.id" class="position-relative">
                                                <td style="max-width: 86px;">
                                                    <a v-if="!item.deleted_at" href="javascript:void(0)" class="btn btn-danger btn-sm py-1 px-2" @click="deleteSlotSerie(item.id)">
                                                        <span class="text-xs">annuler</span>
                                                    </a>
                                                </td>
                                                <td style="min-width: 120px;">
                                                    <div>
                                                        Du <b>{{ formatLocaleDateTime(item.start_date).date }}</b>
                                                    </div>
                                                    <div>
                                                        À <b>{{ formatLocaleDateTime(item.end_date).date }}</b>
                                                    </div>
                                                    <div>
                                                        Chaque <b>{{ item.every_weeks }} semaine(s)</b>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="text-muted">
                                                        <b class="text-dark">{{ formatWeekdays(item.weekdays) || formatLocaleDateTime(item.start_date).date.split(' ')[0] }}</b>
                                                        <br>de {{ item.start_time }} à {{ item.end_time }}
                                                    </div>
                                                </td>
                                                <td>
                                                    <span :class="slotStatuses[item.status].class" class="badge badge-pill p-2">
                                                        {{ slotStatuses[item.status].label }}
                                                    </span>
                                                    <span class="badge badge-secondary badge-pill p-2 mx-1" v-if="item.status == 'blocked' && item.slots">{{ item.slots[0].notes }}</span>
                                                    <span class="d-block pt-1" v-else-if="item.sale_price">{{ item.sale_price }}<sup>DT</sup></span>
                                                </td>
                                                <td style="min-width: 120px;">
                                                    <span v-if="item.deleted_at">{{ formatLocaleDateTime(item.deleted_at).date }} à {{ formatLocaleDateTime(item.deleted_at).time }}</span>
                                                    <span v-else>-</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- PAGINATION -->
                                <nav class="mt-3">
                                    <ul class="pagination justify-content-center">
                                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                            <button class="page-link text-dark" @click="goToPage(currentPage - 1)">
                                                <span class="material-symbols-outlined text-sm">arrow_back</span>
                                            </button>
                                        </li>
                                        <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
                                            <button class="page-link" @click="goToPage(page)" :class="{ 'text-white': currentPage === page, 'text-muted': currentPage !== page }">
                                                {{ page }}
                                            </button>
                                        </li>
                                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                            <button class="page-link text-dark" @click="goToPage(currentPage + 1)">
                                                <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <layout-footer />
    </div>

    <!-- Modal -->
    <!-- <Teleport to="body"> -->
    <div class="modal fade" id="slotDetailsModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ updateSlotModalTitle || 'Détails Créneau'}}</h5>
                    <div v-if="currentSlot.status == 'available'">
                        <a class="btn text-sm d-inline-block p-0" data-toggle="dropdown" aria-expanded="false">
                            <i class="material-symbols-outlined text-lg">more_vert</i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right rounded-lg">
                            <a href="javascript:void(0)" class="dropdown-item"
                                @click="openUpdateSlotModal('booking', 'Réserver', currentSlot)"
                                v-if="currentUser.role !== 'owner'">Réserver</a>
                            <a href="javascript:void(0)" class="dropdown-item"
                                @click="openUpdateSlotModal('blocking', 'Bloquer', currentSlot)">Bloquer</a>
                            <a href="javascript:void(0)" class="dropdown-item"
                                @click="openUpdateSlotModal('price', 'Changer Prix', currentSlot)">Changer prix</a>
                        </div>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-else>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="d-flex justify-content-between align-items-top mb-2">
                        <div class="text-sm">
                            <div>{{ formatLocaleDateTime(currentSlot.start_time).date }}</div>
                            <div v-if="['', 'blocking', 'price'].includes(updateSlotModalType)">{{ formatTime(currentSlot.start_time) }} - {{ formatTime(currentSlot.end_time) }}</div>
                            <!-- <div v-else-if="[''].includes(updateSlotModalType)" class="d-flex justify-content-start align-items-center my-1"> -->
                            <div v-else class="d-flex justify-content-start align-items-center my-1">
                                <input type="text" v-model="currentUpdateSlot.start_time" placeholder="HH:mm" :disabled="['price'].includes(updateSlotModalType)"
                                    style="height: auto;min-height: auto;padding: 0 5px;width: 64px;font-size: inherit;" class="form-control text-center">
                                <span class="mx-1">-</span>
                                <input type="text" v-model="currentUpdateSlot.end_time" placeholder="HH:mm" :disabled="['price'].includes(updateSlotModalType)"
                                    style="height: auto;min-height: auto;padding: 0 5px;width: 64px;font-size: inherit;" class="form-control text-center">
                            </div>
                            <div>Terrain {{ currentFacility?.name }}</div>
                        </div>
                        <div v-if="currentSlot.status" class="w-50 pl-2">
                            <div class="d-flex justify-content-start mb-2">
                                <span :class="slotStatuses[currentSlot.status].class" class="badge badge-pill p-2 mr-1">
                                    {{ slotStatuses[currentSlot.status].label }}
                                </span>
                                <div v-if="currentSlot.status == 'booked'">
                                    <span class="badge badge-pill badge-primary p-2" v-if="currentSlot.channel == 'website'">via 6v6</span>
                                    <span class="badge badge-pill badge-secondary p-2" v-else-if="currentSlot.channel == 'owner'">hors 6v6</span>
                                </div>
                            </div>
                            <span class="d-block pb-1" v-if="currentSlot.status !== 'blocked'">Prix: {{ currentSlot.sale_price || currentSlot.price }}<sup>DT</sup></span>
                        </div>
                    </div>
                    <div class="py-3 px-2 mb-2 rounded-xl bg-light w-100" v-if="['blocked','booked'].includes(currentSlot.status)">
                        <span v-if="currentSlot?.bookings?.length > 0">
                            <span>Réservé par {{ currentSlot.bookings[0]?.user_name }}</span>
                        </span>
                        <span class="px-1 d-block">{{ currentSlot.notes }}</span>
                    </div>
                    <div class="p-3 mb-2 rounded-xl bg-light w-100" v-if="updateSlotModalType">
                        <div class="form-group card-label" v-if="['price'].includes(updateSlotModalType)">
                            <label>Nouveau Prix</label>
                            <input type="number" min="0" class="form-control" style="height: calc(1.5em + .5rem + 2px);padding: .25rem .5rem;font-size: .875rem;border-radius: .2rem;"
                                v-model="currentSlot.sale_price" required/>
                        </div>
                        <div class="form-row" v-if="['price', 'blocking'].includes(updateSlotModalType)">
                            <div class="form-group card-label col-md-6">
                                <label>{{ updateSlotModalType == 'price' ? 'Entre' : 'De' }}</label>
                                <input type="text" placeholder="HH:mm" class="form-control" v-model="currentUpdateSlot.start_time">
                            </div>

                            <div class="form-group card-label col-md-6">
                                <label>{{ updateSlotModalType == 'price' ? 'Et' : 'À' }}</label>
                                <input type="text" placeholder="HH:mm" class="form-control" v-model="currentUpdateSlot.end_time">
                            </div>
                        </div>
                        <div v-if="updateSlotModalType == 'booking'">
                            <div class="card-label mb-1">
                                <label>Réservation via:</label>
                            </div>
                            <div class="custom-control custom-radio ml-2" v-if="currentUser.role !== 'owner'">
                                <input type="radio" id="slotChannel1" name="slotChannel" v-model="currentSlot.channel"
                                    value="website" class="custom-control-input">
                                <label class="custom-control-label" for="slotChannel1">6v6</label>
                            </div>
                            <div class="custom-control custom-radio ml-2">
                                <input type="radio" id="slotChannel2" name="slotChannel" v-model="currentSlot.channel"
                                    value="owner" class="custom-control-input">
                                <label class="custom-control-label" for="slotChannel2">Propriétaire</label>
                            </div>
                        </div>
                        <div v-if="['booking', 'blocking'].includes(updateSlotModalType)">
                            <!-- <span class="h5 mb-2 d-block"><b>Infos Client:</b></span> -->
                            <div class="row my-1">
                                <div class="col-6 d-none">
                                    <input type="text" class="form-control p-2" placeholder="Nom Complet" v-model="currentSlot.user_name" style="min-height: 38px;"/>
                                </div>
                                <div class="col-6 d-none">
                                    <input type="text" class="form-control p-2" placeholder="N° Téléphone" v-model="currentSlot.user_phone" style="min-height: 38px;"/>
                                </div>
                                <div class="col-12">
                                    <textarea class="form-control" rows="3" placeholder="Notes" v-model="currentSlot.notes"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-left align-items-center mb-2" v-if="updateSlotModalType">
                        <label class="mb-0">Est répétitif?</label>
                        <div class="custom-control custom-switch ml-2">
                            <input type="checkbox" class="custom-control-input" v-model="currentUpdateSlot.is_recurrent" @change="loadDatepicker" id="recurrent" />
                            <label class="custom-control-label" for="recurrent"></label>
                        </div>
                    </div>
                    <div v-if="currentUpdateSlot.is_recurrent" class="mb-3">
                        <div class="d-flex justify-content-left align-items-center">
                            <span class="mr-1">Chaque</span>
                            <input type="number" min="1" value="1" class="form-control form-control-sm" v-model="currentUpdateSlot.every_weeks"
                                style="min-height: auto;width: 60px; padding: 0 5px;" />
                            <span class="ml-1">semaine(s)</span>
                        </div>
                        <div class="d-flex justify-content-left align-items-center pt-2 pb-1">
                            <span class="mr-1">Jour(s)</span>
                            <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
                                <label v-for="day in weekdayOptions" :key="day.value"
                                    class="btn btn-outline-secondary flex-fill"
                                    :class="{ active: currentUpdateSlot.weekdays.includes(day.value) }">
                                    <input type="checkbox" :value="day.value" v-model="currentUpdateSlot.weekdays"
                                        autocomplete="off">
                                    {{ day.label }}
                                </label>
                            </div>
                        </div>
                        <div class="d-block">
                            <div class="d-flex align-items-center mt-2">
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="customRadioInline2" name="customRadioInline" v-model="currentUpdateSlot.condition" value="until" class="custom-control-input">
                                    <label class="custom-control-label" for="customRadioInline2"></label>
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class="mr-1">Jusqu'à</span>
                                    <input type="text" class="form-control form-control-sm recurrent-slot-price-until" v-model="currentUpdateSlot.until" :disabled="currentUpdateSlot.condition !== 'until'"
                                        style="min-height: auto;width: 120px; padding: 0 5px; border: 1px solid lightgray;">
                                </div>
                            </div>
                            <div class="d-flex align-items-center mt-2" v-if="false">
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="customRadioInline1" name="customRadioInline" v-model="currentUpdateSlot.condition" value="occurences" class="custom-control-input">
                                    <label class="custom-control-label" for="customRadioInline1"></label>
                                </div>
                                <div class="d-flex align-items-center">
                                    <span class="mr-1">Ou pour</span>
                                    <input type="number" min="2" value="1" class="form-control form-control-sm mr-1"
                                        style="min-height: auto;width: 60px; padding: 0 5px;" v-model="currentUpdateSlot.occurences" :disabled="currentUpdateSlot.condition !== 'occurences'"/>
                                    <span class="">occurence(s)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button v-if="!updateSlotModalType" type="button" class="btn btn-outline-secondary btn-rounded btn-sm" data-dismiss="modal">Retour</button>
                    <button v-else type="button" class="btn btn-outline-secondary btn-rounded btn-sm" @click="cancelSlotUpdate()">Retour</button>
                    <button v-if="!updateSlotModalType && passedSlot(['booked', 'blocked']) && currentSlot.channel != 'owner'" type="button" class="btn btn-danger btn-rounded btn-sm" data-dismiss="modal">Non-présent</button>
                    <button v-if="!updateSlotModalType && futureSlot(['booked', 'blocked'])" @click="cancelBookedSlot(currentSlot.id)" type="button" class="btn btn-danger btn-rounded btn-sm" data-dismiss="modal">Annuler</button>
                    <button v-if="updateSlotModalType == 'price'" type="button" class="btn btn-primary btn-rounded btn-sm" @click="changePrice(currentUpdateSlot)">Changer</button>
                    <button v-if="updateSlotModalType == 'booking'" type="button" class="btn btn-danger btn-rounded btn-sm" @click="bookSlot(currentUpdateSlot)">Réserver</button>
                    <button v-if="updateSlotModalType == 'blocking'" type="button" class="btn btn-danger btn-rounded btn-sm" @click="blockSlot(currentUpdateSlot)">Bloquer</button>
                </div>
            </div>
        </div>
    </div>
    <!-- </Teleport> -->

</template>
<style>
    .nav-tabs.nav-justified>li>a {
        width: max-content;
    }

    .ui-datepicker {
        z-index: 1150 !important;
        /* Bootstrap modal is usually 1050 */
        position: absolute !important;
    }

    .period-navigator {
        min-height: 38px;
    }
</style>
<style scoped>
    :deep(.fc) {
        font-family: inherit;
    }

    :deep(.fc .fc-button-primary) {
        background-color: #007bff;
        border-color: #007bff;
    }

    :deep(.fc .fc-button-primary:hover) {
        background-color: #0069d9;
        border-color: #0062cc;
    }

    :deep(.fc-daygrid-event) {
        border-radius: 3px;
        padding: 1px 4px;
        cursor: pointer;
    }

    .custom-title {
        font-size: 1rem;
    }

    /* details icon: hidden by default, shown only on mobile */
    :deep(.fc-event-details-icon) {
        display: none;
        font-size: 0.7rem;
        margin-left: auto;
    }

    :deep(.day-slot-summary) {
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding: 1px 4px;
    }

    :deep(.day-slot-summary .fc-event) {
        margin-bottom: 1px;
    }

    @media (max-width: 576px) {
        :deep(.fc-event-details-icon) {
            display: inline-block;
        }

        :deep(.fc-toolbar) {
            flex-direction: column;
            gap: 8px;
        }

        :deep(.fc-button) {
            padding: 0.25rem 0.5rem;
            font-size: 0.8rem;
        }

        :deep(.fc-daygrid-day-number) {
            font-size: 0.75rem;
        }

        :deep(.fc-col-header-cell-cushion) {
            font-size: 0.75rem;
            padding: 2px;
        }
    }
</style>
<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import frLocale from '@fullcalendar/core/locales/fr'
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import VendorSidebar from "@/components/Vendors/Partials/Sidebar";

export default {
    components: {
        FullCalendar,
        "vendor-sidebar": VendorSidebar,
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        totalPages() {
            return Math.ceil(this.slotSeries.length / this.perPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.slotSeries.slice(start, start + this.perPage);
        },
    },
    data() {
        return {
            viewMode: null,       // 'day' | 'week' | 'month'
            singleDate: null,     // set when viewMode === 'day'
            startDate: null,      // set when viewMode === 'week' or 'month'
            endDate: null,
            now: moment().format('YYYY-MM-DDTHH:mm:ss'),
            minCalendarDays: 0,
            formattedDate: null,
            selectedDate: null,
            selectedFacility: null,
            selectedEstablishment: null,
            currentFacility: null,
            establishment: null,
            establishments: [],
            facilities: [],
            slots: [],
            slotStatuses: {
                'expired': {'label': 'expiré', 'class': 'bg-danger-light', 'color': '#ED433770', 'title': 'Expiré'},
                'blocked': {'label': 'bloqué', 'class': 'bg-danger-light', 'color': '#ED433770', 'title': 'Bloqué'},
                'booked': {'label': 'réservé', 'class': 'bg-danger text-white font-weight-bolder', 'color': '#ED433770', 'title': 'Réservé'},
                'available': {'label': 'disponible', 'class': 'bg-success-light', 'color': '#19875470', 'title': 'Disponible'},
                'pending': {'label': 'rés. en cours', 'class': 'bg-warning-light', 'color': '#FF660070', 'title': 'Rés. en cours'},
            },
            weekdayOptions: [
                { value: 0, label: 'Lun' },
                { value: 1, label: 'Mar' },
                { value: 2, label: 'Mer' },
                { value: 3, label: 'Jeu' },
                { value: 4, label: 'Ven' },
                { value: 5, label: 'Sam' },
                { value: 6, label: 'Dim' }
            ],
            defaultUpdateSlot: {
                start_time: null,
                end_time: null,
                is_recurrent: false,
                every_weeks: 1,
                weekdays: [],
                condition: 'until',
                occurences: 1,
                until: null,
                is_v2_api: true
            },
            currentUpdateSlot: {},
            currentSlot: {},
            updateSlotModalTitle: '',
            updateSlotModalType: '',
            slotSeries: [],
            currentPage: 1,     // selected page
            perPage: 5,         // items per page
            selectedEvent: null,
            currentTitle: '',
            calendarOptions: {
                plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
                initialView: 'timeGridDay',
                nowIndicator: true,
                locale: frLocale,
                headerToolbar: {
                    left: 'prev,next today',
                    center: '',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                height: 'auto',
                aspectRatio: 1.5,
                handleWindowResize: true,
                windowResizeDelay: 100,

                // custom button label
                buttonText: {
                    today: "Aujourd'hui",
                    month: 'Mois',
                    week: 'Semaine',
                    day: 'Jour',
                    list: 'Jour'   // fallback label
                },
                views: {},
                // read-only, no create/drag
                editable: false,
                droppable: false,
                selectable: false,
                eventStartEditable: false,
                eventDurationEditable: false,
                dayMaxEvents: true,
                events: [],
                // custom event rendering (adds a "details" icon on mobile)
                eventContent: this.renderEventContent,
                datesSet: this.handleDatesSet,
                eventClick: this.handleEventClick,
                windowResize: this.handleWindowResize
            }
        }
    },
    mounted() {
        if (this.currentUser.role == 'owner') {
            this.getEstablishment()
            this.getFacilities()
        } else {
            this.getEstablishments()
        }
        this.applyResponsiveOptions(window.innerWidth)
        $('#slotDetailsModal').on('hidden.bs.modal', () => {
            this.selectedEvent = null
            this.currentSlot = {}
            this.updateSlotModalType = ''
            this.updateSlotModalTitle = ''
            this.currentUpdateSlot = { ...this.defaultUpdateSlot }
        })
    },
    methods: {
        handleDatesSet(arg) {
            this.currentTitle = arg.view.title
            const calendarApi = this.$refs.fullCalendar.getApi()
            calendarApi.setOption('eventDisplay', arg.view.type === 'dayGridMonth' ? 'none' : 'auto')
            this.updateViewDates(arg.view)
        },
        renderEventContent(arg) {
            const $wrapper = $('<div>')
                .addClass('d-flex align-items-center')
                .css({
                    gap: '4px',
                    backgroundColor: arg.event.backgroundColor || arg.event.borderColor || '#3788d8',
                    color: arg.event.textColor || '#fff',
                    width: '100%',
                    height: '100%',
                    padding: '2px 4px',
                    borderRadius: '3px',
                    boxSizing: 'border-box'
                });

            const $dot = $('<span>')
                .addClass('fc-event-dot-custom');

            let details = arg.event.extendedProps.notes
            if (['booked'].includes(arg.event.extendedProps.status) && arg.event.extendedProps?.bookings?.length > 0) { 
                details = arg.event.extendedProps.bookings[0]?.user_name
            }
            const $title = $('<span>')
                .addClass('fc-event-title-custom')
                .text(arg.event.title + (details ? ' - ' + details : ''));
            
            const $price = $('<span>')
                .addClass('fc-event-price-custom').css({ float: 'left' })
                .text(arg.event.extendedProps.sale_price ? arg.event.extendedProps.sale_price : arg.event.extendedProps.price);
            $price.append($('<sup>DT</sup>'));
            if (arg.event.extendedProps.available) $title.append($('<br/>'), $price);

            const $icon = $('<i>')
                .addClass('fa fa-info-circle fc-event-details-icon');

            $wrapper.append($dot, $title, $icon);

            return {
                domNodes: [$wrapper[0]]
            };
        },
        renderEventContent1(arg) {
            const dotEl = document.createElement('span')
            dotEl.classList.add('fc-event-dot-custom')

            const titleEl = document.createElement('span')
            titleEl.classList.add('fc-event-title-custom')
            titleEl.innerText = arg.event.title

            const iconEl = document.createElement('i')
            iconEl.classList.add('fa', 'fa-info-circle', 'fc-event-details-icon')

            const wrapper = document.createElement('div')
            wrapper.classList.add('d-flex', 'align-items-center')
            wrapper.style.gap = '4px'
            wrapper.style.backgroundColor = arg.event.backgroundColor || arg.event.borderColor || '#3788d8'
            wrapper.style.color = arg.event.textColor || '#fff'
            wrapper.style.width = '100%'
            wrapper.style.height = '100%'
            wrapper.style.padding = '2px 4px'
            wrapper.style.borderRadius = '3px'
            wrapper.style.boxSizing = 'border-box'

            wrapper.appendChild(dotEl)
            wrapper.appendChild(titleEl)
            wrapper.appendChild(iconEl)

            return { domNodes: [wrapper] }
        },
        handleEventClick(info) {
            info.jsEvent.preventDefault()
            this.selectedDate = new Date(info.event.start)

            this.selectedEvent = {
                title: info.event.title,
                start: info.event.start,
                end: info.event.end,
                allDay: info.event.allDay,
                extendedProps: info.event.extendedProps || {}
            }
            if (this.selectedEvent.extendedProps.id) this.getSlot(this.selectedEvent.extendedProps.id)
            else this.currentSlot = { ...info.event.extendedProps } 
            // wait a tick so selectedEvent renders in the DOM before showing
            this.$nextTick(() => {
                $('#slotDetailsModal').modal('show')
            })
        },
        cancelSlotUpdate() {
            this.updateSlotModalType = ''
            this.updateSlotModalTitle = ''
            this.currentUpdateSlot = { ...this.defaultUpdateSlot }
        },
        updateViewDates(view) {
            switch (view.type) {
                case 'timeGridDay':
                    this.viewMode = 'day'
                    this.singleDate = this.formatCalendarDate(view.activeStart)
                    this.startDate = null
                    this.endDate = null
                    break

                case 'timeGridWeek':
                    this.viewMode = 'week'
                    this.singleDate = null
                    this.startDate = this.formatCalendarDate(view.activeStart)
                    this.endDate = this.formatCalendarDate(this.inclusiveEnd(view.activeEnd))
                    break

                case 'dayGridMonth':
                    this.viewMode = 'month'
                    this.singleDate = null
                    this.startDate = this.formatCalendarDate(view.activeStart)
                    this.endDate = this.formatCalendarDate(this.inclusiveEnd(view.activeEnd))
                    break

                default:
                    this.viewMode = null
                    this.singleDate = null
                    this.startDate = null
                    this.endDate = null
            }
        },
        // activeEnd is exclusive (day after the last visible day) — subtract 1 to make it inclusive
        inclusiveEnd(date) {
            // activeEnd is exclusive → subtract one day in Tunis timezone
            const d = new Date(date);
            d.setDate(d.getDate() - 1); // local subtraction
            return d;
        },
        formatEventDate(event) {
            const options = event.allDay
                ? { day: 'numeric', month: 'long', year: 'numeric' }
                : { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }

            const startStr = event.start.toLocaleString('fr-FR', options)
            if (!event.end) return startStr

            const endStr = event.end.toLocaleString('fr-FR', options)
            return `${startStr} — ${endStr}`
        },

        handleWindowResize(arg) {
            this.applyResponsiveOptions(arg.view.calendar.el.offsetWidth)
        },

        applyResponsiveOptions(width) {
            if (width < 576) {
                this.calendarOptions.headerToolbar = {
                    left: 'prev,next,today',
                    center: '',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                }
                this.calendarOptions.footerToolbar = false
                this.calendarOptions.aspectRatio = 0.8
            } else if (width < 768) {
                this.calendarOptions.headerToolbar = {
                    left: 'prev,next today',
                    center: '',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                }
                this.calendarOptions.footerToolbar = false
                this.calendarOptions.aspectRatio = 1.2
            } else {
                this.calendarOptions.headerToolbar = {
                    left: 'prev,next today',
                    center: '',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                }
                this.calendarOptions.footerToolbar = false
                this.calendarOptions.aspectRatio = 1.5
            }
        },
        // --- month view: grouped-by-status badges per day ---
        formatCalendarDate(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        renderDaySummary(dateStr) {
            const dayEvents = this.calendarOptions.events.filter(e => e.start.startsWith(dateStr))
            if (dayEvents.length === 0) return
            
            const $calendarRoot = $(this.$refs.fullCalendar.$el)
            const $cell = $calendarRoot.find(`.fc-daygrid-day[data-date="${dateStr}"]`)

            if (!$cell.length) {
                console.warn(`No cell found for computed date ${dateStr}, arg.el had ${elDateStr}`)
                return // bail out rather than write into the wrong cell
            }

            const grouped = dayEvents.reduce((acc, e) => {
                const status = e.extendedProps?.status || 'available'
                if (!acc[status]) acc[status] = { count: 0 }
                acc[status].count++
                return acc
            }, {})

            const $container = $('<div>').addClass('day-slot-summary')

            Object.entries(grouped).forEach(([status, { count }]) => {
                const label = this.slotStatuses[status].title || status

                const $title = $('<div>')
                    .addClass('fc-event-title fc-sticky')
                    .text(`${count} ${label}${status != "pending" ? "(s)" : ""}`)

                const $frame = $('<div>')
                    .addClass('fc-event-main')
                    .append($title)

                const $eventEl = $('<a>')
                    .addClass('fc-daygrid-event fc-daygrid-block-event fc-event fc-event-start fc-event-end')
                    .css({
                        backgroundColor: this.slotStatuses[status].color,
                        borderColor: this.slotStatuses[status].color,
                        cursor: 'pointer'
                    })
                    .append($frame)
                    .on('click', (e) => {
                        e.stopPropagation()
                        this.goToDay(dateStr)
                    })

                $container.append($eventEl)
            })

            const $eventsFrame = $cell.find('.fc-daygrid-day-events')
            if ($eventsFrame.length) {
                $eventsFrame.append($container)
            } else {
                $cell.find('.fc-daygrid-day-frame').append($container)
            }
        },

        // clicking anywhere else on the day cell (not just the badges) -> same behavior
        handleDateClick(info) {
            // only act in month view; in week/day view a date-click isn't meaningful here
            if (this.$refs.fullCalendar.getApi().view.type === 'dayGridMonth') {
                this.goToDay(info.dateStr)
            }
        },
        goToDay(dateStr) {
            const calendarApi = this.$refs.fullCalendar.getApi()
            calendarApi.changeView('timeGridDay', dateStr)
        },
        formatDateTime(datetimeString) {
            if (!datetimeString) return "";
            const formattedDate = datetimeString.split("T")[0];
            const datetime = {
                date: datetimeString.split("T")[0],
                time: datetimeString.split("T")[1].substring(0,5),
            };
            return datetime;
        },
        formatTime(datetimeString) {
            if (!datetimeString) return '';
            const date = new Date(datetimeString);
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        },
        getSlot(id) {
            api.get('/private/slots/'+id)
                .then(response => {
                    const result = response.data
                    this.currentSlot = result
                })
        },
        getEstablishments() {
            api.get('/private/establishment/list')
                .then(response => {
                    const result = response.data
                    this.establishments = result
                })
        },
        getEstablishment() {
            api.get('/private/establishment/')
                .then(response => {
                    const result = response.data
                    this.establishment = this.selectedEstablishment = result
                })
        },
        getFacilities() {
            api.get('/private/facilities')
                .then(response => {
                    const result = response.data
                    this.facilities = result
                    if (this.selectedEstablishment) {
                        this.facilities = this.facilities.filter(f => f.establishment_id == this.selectedEstablishment.id)
                    }
                    this.selectedFacility = this.facilities.length > 0 ? this.facilities[0].id : null
                })
        },
        getFacilitySlots() {
            if (!this.selectedFacility && (!this.singleDate || !this.startDate && !this.endDate))
                return
            const url = (this.viewMode == "day") ? '/private/slots/'+this.singleDate+'/facility/'+this.selectedFacility : 
                '/private/slots/'+this.startDate+'/'+this.endDate+'/facility/'+this.selectedFacility
            api.get(url)
                .then(response => {
                    const result = response.data
                    this.slots = result.filter(slot => !slot.available || slot.start_time > moment().format("YYYY-MM-DDTHH:mm:ss.000000"))
                    console.log('Fetched slots:', this.slots)  // Debugging line
                    let events = []
                    this.slots.forEach((slot, index) => {
                        let event = {
                            "id": index,
                            "title": this.slotStatuses[slot.status].title, // EED202
                            "start": slot.start_time,
                            "end": slot.end_time,
                            "color": this.slotStatuses[slot.status].color,
                            "extendedProps": slot
                        }
                        events.push(event)
                    });
                    this.calendarOptions.events = events
                    const $calendarRoot = $(this.$refs.fullCalendar.$el);
                    $calendarRoot.find('.day-slot-summary').remove();
                    if (this.viewMode === 'month') {
                        // alert('Rendering day summaries for month view...');
                        const dates = [];
                        let current = new Date(this.startDate);
                        const end = new Date(this.endDate);

                        while (current <= end) {
                            const dateStr = this.formatCalendarDate(current); // YYYY-MM-DD
                            this.renderDaySummary(dateStr);
                            current.setDate(current.getDate() + 1);
                        }
                    }
                })
        },
        getFacilitySlotSeries() {
            api.get('/private/slots/series/'+this.selectedFacility)
                .then(response => {
                    const result = response.data
                    this.slotSeries = result.filter(s => !s.deleted_at)
                })
        },
        changePrice(updateSlot) {
            this.currentSlot.status = 'available'
            this.currentSlot.sale_price = parseInt(this.currentSlot.sale_price) ? parseInt(this.currentSlot.sale_price) : null
            this.currentSlot.available = true
            this.currentSlot.expires_at = null
            updateSlot.slot = this.currentSlot
            api.post('/private/slots/'+this.selectedFacility+'/sale_price/v2', updateSlot)
                .then(response => {
                    this.cancelSlotUpdate()
                    this.getFacilitySlots()
                    alert('Le prix a été mis à jour avec succès.')
                })
                .catch(error => {
                    alert('Une erreur est survenue lors de la mise à jour du prix.')
                })
        },
        bookSlot(updateSlot) {
            this.currentSlot.status = 'booked'
            this.currentSlot.available = false
            this.expires_at = null
            this.currentSlot.sale_price = null
            updateSlot.slot = this.currentSlot
            api.post('/private/slots/'+this.selectedFacility+'/book', updateSlot)
                .then(response => {
                    this.cancelSlotUpdate()
                    this.getFacilitySlots()
                    alert('Le(s) créneau(x) a été réservé avec succès.')
                })
                .catch(error => {
                    alert('Une erreur est survenue lors de la réservation de(s) créneau(x).')
                })
        },
        blockSlot(updateSlot) {
            this.currentSlot.status = 'blocked'
            this.currentSlot.available = false
            this.expires_at = null
            this.currentSlot.sale_price = null
            updateSlot.slot = this.currentSlot
            api.post('/private/slots/'+this.selectedFacility+'/block', updateSlot)
                .then(response => {
                    this.cancelSlotUpdate()
                    this.getFacilitySlots()
                    alert('Le(s) créneau(x) a été bloqué avec succès.')
                })
                .catch(error => {
                    alert('Une erreur est survenue lors du blocage de(s) créneau(x).')
                })
        },
        cancelBookedSlot(slot_id) {
            this.$store.dispatch('modal/triggerModal', {
                icon: 'warning',
                icon_color: 'text-warning',
                title: 'Confirmation',
                detail: "Êtes-vous sûr de vouloir annuler cette réservation ?",
                prompt: true,
                onResult: (confirmed) => {
                    if(confirmed) {
                        api.post('/private/slots/'+slot_id+'/cancel')
                            .then(response => {
                                this.getFacilitySlots()
                                this.getFacilitySlotSeries()
                                alert('La réservation a été annulée avec succès.')
                            })
                    }
                }
            })
        },
        deleteSlotSerie(serie_id) {
            this.$store.dispatch('modal/triggerModal', {
                icon: 'warning',
                icon_color: 'text-warning',
                title: 'Confirmation',
                detail: 'Êtes-vous sûr de vouloir annuler cette série de créneaux ?',
                prompt: true,
                onResult: (confirmed) => {
                    if (confirmed) {
                        api.delete('/private/slots/series/' + serie_id)
                            .then(response => {
                                this.getFacilitySlots()
                                this.getFacilitySlotSeries()
                            })
                            .catch(error => {
                            })
                    }
                }
            })
        },
        openUpdateSlotModal(modalType, modalTitle, slot) {
            this.updateSlotModalType = modalType
            this.updateSlotModalTitle = modalTitle
            this.currentUpdateSlot = { ...this.defaultUpdateSlot }
            this.currentSlot = { ...slot }
            this.currentUpdateSlot.start_time = this.formatTime(slot.start_time)
            this.currentUpdateSlot.end_time = this.formatTime(slot.end_time)
            if (this.currentUser.role == 'owner') {
                this.currentSlot.channel = 'owner'
            }
            // JavaScript: Sunday=0 ... Saturday=6
            const jsDay = this.selectedDate.getDay()
            // Convert to Python: Monday=0 ... Sunday=6
            const pythonDay = (jsDay + 6) % 7

            if (!this.currentUpdateSlot.weekdays.includes(pythonDay)) {
                this.currentUpdateSlot.weekdays.push(pythonDay)
            }
        },
        loadDatepicker() {
            if (this.currentUpdateSlot.is_recurrent) {
                const vm = this
                const defaultDate = new Date(this.currentSlot.start_time);
                const minDate = new Date(this.currentSlot.start_time);
                // const delta = 7 * this.currentUpdateSlot.every_weeks
                // minDate.setDate(minDate.getDate() + delta);
                $('.recurrent-slot-price-until').datepicker({
                    dateFormat: 'yy-mm-dd',
                    minDate: minDate,
                    defaultDate: defaultDate,
                    appendTo: 'body',
                    onSelect: (dateText) => {
                        vm.currentUpdateSlot.until = dateText;
                        // const selectedDate = $.datepicker.parseDate("d M yy", dateText);
                        // const formatted = $.datepicker.formatDate("yy-mm-dd", selectedDate);
                        // vm.formattedDate = dateText;
                    }
                });
            }
        },
        formatLocaleDateTime(datetimeString) {
            if (!datetimeString) return "";
            const date = new Date(datetimeString);
            const formattedDate = date.toLocaleString("fr-FR", { timeZone: "Africa/Tunis" }).split("T")[0];
            let displayDate = date.toLocaleDateString("fr-FR", { weekday: "short", year: "numeric", month: "short", day: "numeric" }).split("T")[0];
            displayDate = displayDate.split(" ") .map(word => word.charAt(0).toUpperCase() + word.slice(1)) .join(" ");
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            let date_obj = {
                date: displayDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` ${hours}:${minutes}`,
            };
            return date_obj;
        },
        formatWeekdays(values) {
            if (!values) return null
            const labels = this.weekdayOptions
                .filter(day => values.includes(day.value))
                .map(day => day.label)

            if (labels.length > 1) {
                return labels.slice(0, -1).join(', ') + ' & ' + labels[labels.length - 1]
            }
            return labels[0] || ''
        },
        futureSlot(statuses) {
            return statuses.includes(this.currentSlot.status) && this.currentSlot.start_time > moment().format('YYYY-MM-DDTHH:mm:ss')
        },
        passedSlot(statuses) {
            return statuses.includes(this.currentSlot.status) && this.currentSlot.start_time <= moment().format('YYYY-MM-DDTHH:mm:ss')
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
    },
    watch: {
        'viewMode': function(newValue) {
            this.getFacilitySlots()
        },
        'singleDate': function(newValue) {
            this.getFacilitySlots()
        },
        'startDate': function(newValue) {
            this.getFacilitySlots()
        },
        'selectedEstablishment': function(newValue) {
            this.getFacilities()
            this.establishment = newValue
            const created_at = moment(this.establishment.created_at)
            const now = moment()
            this.minCalendarDays = now.diff(created_at, 'days')
        },
        'selectedFacility': function(newValue) {
            this.getFacilitySlots()
            this.getFacilitySlotSeries()
            const facilities = this.facilities.filter(facility => facility.id == newValue)
            this.currentFacility = (facilities.length > 0) ? facilities[0] : null
        },
        'currentUpdateSlot.every_weeks': function(newValue) {
            const minDate = new Date(this.currentSlot.start_time);
            const delta = 7 * newValue
            minDate.setDate(minDate.getDate() + delta);
            $('.recurrent-slot-price-until').datepicker("option", "minDate", minDate);
            $('.recurrent-slot-price-until').datepicker("refresh");
        },
        'currentUpdateSlot.start_time': function(newValue) {
            const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
            if (regex.test(newValue)) {
                const start_time = this.formatDateTime(this.currentSlot.start_time)
                this.currentSlot.start_time = start_time.date+'T'+newValue+':00'
            }
        },
        'currentUpdateSlot.end_time': function(newValue, oldValue) {
            const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
            if (regex.test(newValue)) {
                let end_time = this.formatDateTime(this.currentSlot.end_time)
                const start_time = this.formatDateTime(this.currentSlot.start_time)
                if (end_time.date > start_time.date) {
                    if (end_time.time < newValue && newValue > start_time.time )
                        end_time = start_time
                }
                this.currentSlot.end_time = end_time.date+'T'+newValue+':00'
            }
        }
    }
};
</script>
